const currentWindow = typeof window === 'undefined' || (window && Object.keys(window).length === 0) ? null : window;

if (currentWindow){
    const fetch = window.fetch;
    
    fetch.Headers = window.Headers;
    fetch.Request = window.Request;
    fetch.Response = window.Response;
    fetch.AbortController = window.AbortController;

    module.exports = fetch;
}
